/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StudyPlanStatusEnum,
    StudyPlanStatusEnumFromJSON,
    StudyPlanStatusEnumFromJSONTyped,
    StudyPlanStatusEnumToJSON,
} from './StudyPlanStatusEnum';

/**
 * 
 * @export
 * @interface UpdateStudyPlanStatusDTO
 */
export interface UpdateStudyPlanStatusDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyPlanStatusDTO
     */
    studyPlanId?: string;
    /**
     * 
     * @type {StudyPlanStatusEnum}
     * @memberof UpdateStudyPlanStatusDTO
     */
    status?: StudyPlanStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyPlanStatusDTO
     */
    message?: string | null;
}

export function UpdateStudyPlanStatusDTOFromJSON(json: any): UpdateStudyPlanStatusDTO {
    return UpdateStudyPlanStatusDTOFromJSONTyped(json, false);
}

export function UpdateStudyPlanStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStudyPlanStatusDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
        'status': !exists(json, 'status') ? undefined : StudyPlanStatusEnumFromJSON(json['status']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function UpdateStudyPlanStatusDTOToJSON(value?: UpdateStudyPlanStatusDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'studyPlanId': value.studyPlanId,
        'status': StudyPlanStatusEnumToJSON(value.status),
        'message': value.message,
    };
}

